<template>
  <div class="home-left">
    <area-division :title="areaInfo.title || ''" :ps-txt="areaInfo.ps_title" :list="areaList" />
    <industry-pillar
      class="m-top"
      :title="pillarInfo.title || ''"
      :ps-txt="pillarInfo.ps_title"
      :list="pillarInfo.data.list || []"
      :total="Number.parseFloat(pillarInfo.data.total || 0)"
    />
    <energy-ring
      class="m-top"
      :title="energyConsumptionInfo.title || ''"
      :ps-txt="energyConsumptionInfo.ps_title"
      :energy-consumption-data="energyConsumptionData"
    />
    <unit-energy class="m-top" :title="unitEnergyConsumption.title || ''" :ps-title="unitEnergyConsumption.ps_title || ''" :option="left4Option" />
  </div>
</template>

<script>
import echarts from 'echarts'
import { mapGetters } from 'vuex'
import AreaDivision from '@/views/Home/components/MapItem/AreaDivision'
import IndustryPillar from '@/views/Home/components/MapItem/IndustryPillar'
import EnergyRing from '@/views/Home/components/MapItem/EnergyRing'
import UnitEnergy from '@/views/Home/components/MapItem/UnitEnergy'
export default {
  name: 'HomeLeft',
  components: { UnitEnergy, EnergyRing, IndustryPillar, AreaDivision },
  data() {
    return {
      areaList: [
        {
          icon: 'jurisdiction-area.png',
          name: '辖区面积',
          remarks: '',
          num: 0,
          unit: '平方公里'
        },
        {
          icon: 'house-icon.png',
          name: '乡镇',
          remarks: '',
          num: 0,
          unit: '个'
        },
        {
          icon: 'village-icon.png',
          name: '行政村',
          remarks: '社区',
          num: 0,
          unit: '个'
        },
        {
          icon: 'men-icon.png',
          name: '人口',
          remarks: '',
          num: 0,
          unit: '万人'
        }
      ],
      left4Option: {
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>产值能耗：{c}tce/万元'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          nameTextStyle: {
            fontSize: 40
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          axisTick: {
            show: false
          },
          data: []
        },
        yAxis: {
          show: false,
          type: 'value'
        },
        series: {
          data: [],
          type: 'line',
          label: {
            show: true,
            position: 'top',
            fontSize: 16,
            formatter: '{c}'
          },
          symbolSize: 14,
          smooth: false,
          color: '#2085E4',
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#2085E4' },
                { offset: 1, color: 'rgba(53,232,206,0)' }
              ])
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'areaInfo',
      'pillarInfo',
      'energyConsumptionInfo',
      'energyConsumptionData',
      'unitEnergyConsumption'
    ])
  },
  watch: {
    areaInfo: {
      handler(newV, oldV) {
        this.areaList = this.areaList.map((item, index) => {
          return {
            ...item,
            num: newV.data[index] || 0
          }
        })
      },
      immediate: true,
      deep: true
    },
    unitEnergyConsumption: {
      handler(newV, oldV) {
        // this.left4Option.xAxis.data = newV.data.map(item => item.date)
        // this.left4Option.series.data = newV.data.map(item => item.num)
        this.$set(this.left4Option.xAxis, 'data', newV.data.map(item => item.date))
        this.$set(this.left4Option.series, 'data', newV.data.map(item => item.num))
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped>
</style>
